// extracted by mini-css-extract-plugin
export default {"drawer":"RightDrawer_drawer__QGmz6","drawer__searchBar":"RightDrawer_drawer__searchBar__zA8ww"};